module.exports = __webpack_public_path__ + "img/9788952212498.d7810ba0.jpg";